import { ShowLinesCommand } from 'slotworks/commands/lines/show-lines-command';
import { DimSymbolsCommand } from 'slotworks/commands/symbols/dim-symbols-command';
import { HighlightSymbolsCommand } from 'slotworks/commands/symbols/highlight-symbols-command';
import { StaticSymbolsCommand } from 'slotworks/commands/symbols/static-symbols-command';
import Components from 'slotworks/components/components';
import Layers from 'slotworks/graphics/layers/layers';
import AbstractMediator from 'slotworks/mediators/abstract-mediator';
import GameState from 'slotworks/model/game-state';
import LineResult from 'slotworks/model/gameplay/records/results/line-result';
import ScatterResult from 'slotworks/model/gameplay/records/results/scatter-result';
import SymbolWinResult from 'slotworks/model/gameplay/records/results/symbol-win-result';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import { SoundEvent } from 'slotworks/sound/sound-events';
import SoundManager from 'slotworks/sound/sound-manager';
import { reject } from 'slotworks/utils/collection-utils';
import { unique } from 'slotworks/utils/collection-utils';
import Contract from 'slotworks/utils/contract';
import Point from 'slotworks/utils/geom/point';
import Timer from 'slotworks/utils/timer';
import settingsModel from 'slotworks/model/settings/settings-model';
import { DisplaySymbolsCommand } from 'slotworks/commands/symbols/display-symbols-command';

export default class AllWinsMediators extends AbstractMediator {
    private remainingSymbols: any;
    private winoverAnimations: any;

    public start(): Contract<void> {
        if (GameState.currentGameHasSymbolWinResults()) {
            const currentRecord = GameState.getCurrentGame().getCurrentRecord();
            const allWins = currentRecord.results;
            let winningPositions: Point[] = [];
            const lines = [];

            const lowWinOnUk = settingsModel.isUKJurisdiction() && !GameState.getCurrentGame().isWinAboveBet();

            for (const win of allWins) {
                if (win instanceof SymbolWinResult) {
                    winningPositions = winningPositions.concat(win.positions);
                }
            }
            for (let i = 0; i < Components.matrix.getAllSymbols().length; i++) {
                Components.matrix.getAllSymbols()[i].setSymbolFade(true);
            }

            let winningSymbols = [];
            const winningSymbolIDs = [];
            const allWinningSymbols = [];
            this.winoverAnimations = [];
            StaticSymbolsCommand().execute();
            for (const result of allWins) {
                if (result instanceof LineResult) {
                    lines.push(result.line);
                }
            }
            ShowLinesCommand(lines).execute();

            for (const position of winningPositions) {
                const symbol = Components.matrix.getSymbol(position.x, position.y);
                if (symbol.symbolId !== 'SC' && symbol.symbolId !== 'BN') {
                    winningSymbols.push(symbol);
                    allWinningSymbols.push(symbol);
                    winningSymbolIDs.push(symbol.symbolId);
                }
            }

            winningSymbols = unique(winningSymbols);
            const uniqueWinningSymbolIDs = unique(winningSymbolIDs);
            SoundManager.event(SoundEvent.highlight_all_wins);
            for (const symbolID of uniqueWinningSymbolIDs) {
                SoundManager.event(SoundEvent.symbol_ID_highlight, symbolID);
                let count = 0;
                for (const symbolToCount of winningSymbolIDs) {
                    if (symbolID === symbolToCount) {
                        count++;
                    }
                }
                SoundManager.event(SoundEvent.symbol_ID_MATCHES_highlight, symbolID, count.toString());
            }

            this.remainingSymbols = reject(Components.matrix.getAllSymbols(), allWinningSymbols);
            DimSymbolsCommand(this.remainingSymbols).execute();
            if (winningSymbols.length === 0 && AllWinsMediators.checkStartFreeSpin()) {
                return new Contract<void>(resolve => {
                    Timer.setTimeout(() => {
                        resolve(null);
                    }, 2000);
                });
            } else {
                if(lowWinOnUk)
                    return DisplaySymbolsCommand(winningSymbols)
                else
                    return HighlightSymbolsCommand(winningSymbols);
            }
        } else {
            return super.start();
        }
    }

    public static checkStartFreeSpin() {
        let record = GameState.getCurrentGame().getCurrentRecord();
        let triggered = false;

        if (record instanceof SpinRecord) {
            triggered = record.freespinsTriggered;
        }

        if (record.beenPaid) {
            triggered = false;
        }

        const r = record.getResultsOfType(ScatterResult) as ScatterResult[];
        if (r && r[0] && r[0].matches >= 3) {
            triggered = true;
        }
        return triggered;
    }

    public end() {
        for (let i = 0; i < this.winoverAnimations.length; i++) {
            Layers.SymbolAnimations.remove(this.winoverAnimations[i]);
            this.winoverAnimations[i].destroy();
        }
        return new Contract<void>(resolve => {
            StaticSymbolsCommand().execute();
            Components.celebrateWin.hide();
            for (let i = 0; i < Components.matrix.getAllSymbols().length; i++) {
                Components.matrix.getAllSymbols()[i].setSymbolFade(true);
            }
            Timer.setTimeout(() => {
                resolve(null);
            }, 1500);
        });
    }
}



// WEBPACK FOOTER //
// ./src/Mediator/all-wins-mediator.ts